import React from 'react'
import { Icon } from '@mobi/component-library/Common/Icon'
import { BetCard } from '@mobi/betslip/Components/Common/BetCard'
import type { BetLoopKambiShareCoupon } from '@core/Areas/BetLoop/types'
import { BetCardTitle } from '@mobi/betslip/Components/Common/BetCardTitle'
import { formatKambiCurrencyWithThousandMultiplier } from '@core/Areas/Kambi/Components/BetHistory/helpers/currencyFormat'
import { CountdownStatus } from '../Common/CountdownStatus'

// TODO:
// * Handle possible SGM legs

export const Multi: React.FC<{
  ticket: BetLoopKambiShareCoupon
}> = ({ ticket }) => {
  const legsCount = ticket.outcomes.length
  const multiTitleText = `${legsCount} Leg Multi`
  const multiCombinedReturn = formatKambiCurrencyWithThousandMultiplier(ticket.bets[0].betOdds)

  return (
    <>
      <BetCardTitle title={multiTitleText} rightComponent={multiCombinedReturn} />

      {ticket.outcomes.map(outcome => {
        const eventName =
          ticket.events.find(e => e.eventId === outcome.eventId)?.eventName ?? 'Unknown Meeting'

        const betOffer = ticket.betOffers.find(
          betOffer => betOffer.betOfferId === outcome.betOfferId
        )
        const couponRow = ticket.couponRows.find(
          couponRow => couponRow.outcomeId === outcome.outcomeId
        )

        return (
          <BetCard.Container key={outcome.outcomeId}>
            <BetCard.EventDetails
              key={outcome.outcomeId}
              iconComponent={<Icon size='1.6rem' type='tab' />}
              heading={eventName}
              statusComponent={<CountdownStatus ticket={ticket} />}
            />

            <BetCard.SelectionInfo
              key={outcome.betOfferId}
              iconComponent={<Icon size='1.6rem' type='tab' />}
              heading={outcome.label}
              subHeading={betOffer?.criterion}
              priceWin={
                couponRow?.playedOdds
                  ? formatKambiCurrencyWithThousandMultiplier(couponRow.playedOdds)
                  : undefined
              }
            />
          </BetCard.Container>
        )
      })}
    </>
  )
}
